import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import {
  Flex,
  Input,
  Select,
  Typography,
  Upload,
  Button,
  Space,
  Tag,
} from "antd"
import { useState, useEffect } from "react"
import { trainersAction } from "src/store/Slices/Administrator/TrainersSlice"
import { useDispatch, useSelector } from "react-redux"
import { getClubs, getTrainerTypes } from "src/store/Slices/DropDownSlice"
import { setErrorNotAllFields } from "src/store/Slices/HelperSlice"
import { UploadOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons"
import { openNotification } from "src/components/helpers/notification"

const { TextArea } = Input

const AddEditTrainerModal = ({
  visible,
  setVisible,
  trainerInfo,
  setPage,
  setPageSize,
}) => {
  const dispatch = useDispatch()

  const [name, setName] = useState("")
  const [type, setType] = useState("")
  const [img, setImg] = useState("")
  const [education, setEducation] = useState("")
  const [seniority, setSeniority] = useState("")
  const [price, setPrice] = useState("")
  const [club, setClub] = useState("")
  const [isTop, setIsTop] = useState(false)
  const [isMaster, setIsMaster] = useState(false)
  const [fileList, setFileList] = useState([])
  const [uploading, setUploading] = useState(false)
  const [tagInput, setTagInput] = useState("")
  const [tags, setTags] = useState([])
  const [description, setDescription] = useState("")
  const [benefits, setBenefits] = useState([
    { BenefitText: "", BenefitDescription: "" },
  ])
  const [educationList, setEducationList] = useState([""])
  const [additionalEducation, setAdditionalEducation] = useState([""])
  const [achievements, setAchievements] = useState([""])

  const trainerTypes = useSelector((state) => state.DropDownSlice.trainerTypes)
  const clubs = useSelector((state) => state.DropDownSlice.clubs)
  const isBuyOptions = [
    { value: true, label: "Да" },
    { value: false, label: "Нет" },
  ]

  useEffect(() => {
    if (visible.flag === "edit") {
      dispatch(getTrainerTypes())
      dispatch(getClubs())
    } else {
      setName("")
      setType("")
      setImg("")
      setEducation("")
      setSeniority("")
      setClub("")
      setPrice("")
      setIsTop(false)
      setIsMaster(false)
      setFileList([])
      setTags([])
      setDescription("")
      setBenefits([{ BenefitText: "", BenefitDescription: "" }])
      setEducationList([""])
      setAdditionalEducation([""])
      setAchievements([""])
    }
  }, [visible.flag])

  useEffect(() => {
    if (visible.flag === "edit" && trainerInfo) {
      setName(trainerInfo?.name)
      setType(
        trainerTypes?.data?.value?.find(
          (el) => el?.label === trainerInfo?.typeName,
        )?.value,
      )
      setImg(trainerInfo?.imageUrl?.props?.src)
      setEducation(trainerInfo?.education?.props?.title || "")
      setSeniority(trainerInfo?.experience?.props?.title)
      setPrice(trainerInfo?.trainingPrice)
      setClub(
        clubs?.data?.value?.find((el) => el?.label === trainerInfo?.clubName)
          ?.value,
      )
      setIsTop(trainerInfo?.isTop === "Нет" ? false : true)
      setIsMaster(trainerInfo?.isMaster === "Нет" ? false : true)
      setFileList([])

      setDescription(trainerInfo?.description || "")

      if (trainerInfo?.tags) {
        let parsedTags = []

        if (Array.isArray(trainerInfo.tags)) {
          if (trainerInfo.tags.length > 0) {
            if (typeof trainerInfo.tags[0] === "string") {
              let tagsString = trainerInfo.tags[0]
              tagsString = tagsString
                .replace(/\[/g, "")
                .replace(/\]/g, "")
                .replace(/"/g, "")
                .replace(/'/g, "")
              parsedTags = tagsString
                .split(/[,\n]/)
                .map((tag) => tag.trim())
                .filter((tag) => tag !== "" && tag !== "[" && tag !== "]")
            } else {
              parsedTags = trainerInfo.tags
                .map((tag) =>
                  typeof tag === "string"
                    ? tag.trim().replace(/"/g, "").replace(/'/g, "")
                    : String(tag),
                )
                .filter((tag) => tag !== "" && tag !== "[" && tag !== "]")
            }
          }
        } else if (typeof trainerInfo.tags === "string") {
          let tagsString = trainerInfo.tags
          tagsString = tagsString
            .replace(/\[/g, "")
            .replace(/\]/g, "")
            .replace(/"/g, "")
            .replace(/'/g, "")
          parsedTags = tagsString
            .split(/[,\n]/)
            .map((tag) => tag.trim())
            .filter((tag) => tag !== "" && tag !== "[" && tag !== "]")
        }

        setTags(parsedTags)
      } else {
        setTags([])
      }

      if (trainerInfo?.benefits && Array.isArray(trainerInfo.benefits)) {
        setBenefits(trainerInfo.benefits)
      } else {
        setBenefits([{ BenefitText: "", BenefitDescription: "" }])
      }

      if (trainerInfo?.additionalEducationList) {
        if (Array.isArray(trainerInfo.additionalEducationList)) {
          const cleanList = trainerInfo.additionalEducationList
            .flatMap((item) => {
              if (typeof item === "string") {
                return item
                  .split(",")
                  .map((s) => s.trim())
                  .filter((s) => s)
              }
              return String(item)
                .split(",")
                .map((s) => s.trim())
                .filter((s) => s)
            })
            .filter((item) => item.trim() !== "")

          setAdditionalEducation(cleanList.length > 0 ? cleanList : [""])
        } else if (typeof trainerInfo.additionalEducationList === "string") {
          const cleanList = trainerInfo.additionalEducationList
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s)
          setAdditionalEducation(cleanList.length > 0 ? cleanList : [""])
        }
      } else {
        setAdditionalEducation([""])
      }

      if (trainerInfo?.educationList) {
        if (Array.isArray(trainerInfo.educationList)) {
          const cleanList = trainerInfo.educationList
            .flatMap((item) => {
              if (typeof item === "string") {
                return item
                  .split(",")
                  .map((s) => s.trim())
                  .filter((s) => s)
              }
              return String(item)
                .split(",")
                .map((s) => s.trim())
                .filter((s) => s)
            })
            .filter((item) => item.trim() !== "")

          setEducationList(cleanList.length > 0 ? cleanList : [""])
        } else if (typeof trainerInfo.educationList === "string") {
          const cleanList = trainerInfo.educationList
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s)
          setEducationList(cleanList.length > 0 ? cleanList : [""])
        }
      } else {
        setEducationList([""])
      }

      if (trainerInfo?.achievement) {
        if (Array.isArray(trainerInfo.achievement)) {
          const cleanList = trainerInfo.achievement
            .flatMap((item) => {
              if (typeof item === "string") {
                return item
                  .split(",")
                  .map((s) => s.trim())
                  .filter((s) => s)
              }
              return String(item)
                .split(",")
                .map((s) => s.trim())
                .filter((s) => s)
            })
            .filter((item) => item.trim() !== "")

          setAchievements(cleanList.length > 0 ? cleanList : [""])
        } else if (typeof trainerInfo.achievement === "string") {
          const cleanList = trainerInfo.achievement
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s)
          setAchievements(cleanList.length > 0 ? cleanList : [""])
        }
      } else {
        setAchievements([""])
      }
    }
  }, [visible, trainerInfo, clubs, trainerTypes])

  const handleTagInputChange = (e) => {
    const value = e.currentTarget.value
    setTagInput(value)
  }

  const handleTagInputKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "," || e.key === ";") {
      e.preventDefault()
      addTags()
    }
  }

  const addTags = () => {
    if (!tagInput.trim()) return

    const newTags = tagInput
      .split(/[,;]/)
      .map((tag) => tag.trim())
      .filter((tag) => tag !== "" && !tags.includes(tag))

    if (newTags.length > 0) {
      const cleanExistingTags = tags.filter((tag) => tag != null && tag !== "")
      const updatedTags = [...cleanExistingTags, ...newTags]
      setTags(updatedTags)
      setTagInput("")
    }
  }

  const removeTag = (indexToRemove) => {
    const updatedTags = tags.filter((_, index) => index !== indexToRemove)
    setTags(updatedTags.filter((tag) => tag != null && tag !== ""))
  }

  const clearAllTags = () => {
    setTags([])
  }

  const handleBenefitChange = (index, field, value) => {
    const newBenefits = [...benefits]
    newBenefits[index][field] = value
    setBenefits(newBenefits)
  }

  const addBenefit = () => {
    setBenefits([...benefits, { BenefitText: "", BenefitDescription: "" }])
  }

  const removeBenefit = (index) => {
    if (benefits.length > 1) {
      const newBenefits = benefits.filter((_, i) => i !== index)
      setBenefits(newBenefits)
    }
  }

  const handleEducationChange = (index, value) => {
    const newEducationList = [...educationList]
    newEducationList[index] = value
    setEducationList(newEducationList)
  }

  const addEducationItem = () => {
    setEducationList([...educationList, ""])
  }

  const removeEducationItem = (index) => {
    if (educationList.length > 1) {
      const newEducationList = educationList.filter((_, i) => i !== index)
      setEducationList(newEducationList)
    }
  }

  const handleAdditionalEducationChange = (index, value) => {
    const newAdditionalEducation = [...additionalEducation]
    newAdditionalEducation[index] = value
    setAdditionalEducation(newAdditionalEducation)
  }

  const addAdditionalEducationItem = () => {
    setAdditionalEducation([...additionalEducation, ""])
  }

  const removeAdditionalEducationItem = (index) => {
    if (additionalEducation.length > 1) {
      const newAdditionalEducation = additionalEducation.filter(
        (_, i) => i !== index,
      )
      setAdditionalEducation(newAdditionalEducation)
    }
  }

  const handleAchievementChange = (index, value) => {
    const newAchievements = [...achievements]
    newAchievements[index] = value
    setAchievements(newAchievements)
  }

  const addAchievementItem = () => {
    setAchievements([...achievements, ""])
  }

  const removeAchievementItem = (index) => {
    if (achievements.length > 1) {
      const newAchievements = achievements.filter((_, i) => i !== index)
      setAchievements(newAchievements)
    }
  }

  const onClickSubmit = () => {
    if (!(name && type && seniority && club)) {
      dispatch(setErrorNotAllFields())
    } else {
      const formData = new FormData()
      fileList.forEach((file) => {
        formData.append("imageFile", file)
      })
      formData.append("id", visible.flag !== "add" ? trainerInfo.id : null)
      formData.append("name", name)
      formData.append("typeId", type)
      formData.append("imageUrl", img)
      formData.append("education", education)
      formData.append("experience", seniority)
      formData.append("clubId", club)
      formData.append("isTop", isTop)
      formData.append("isMaster", isMaster)
      formData.append("trainingPrice", price)

      const filteredTags = tags
        .filter((tag) => tag != null && tag !== "")
        .map((tag) => (typeof tag === "string" ? tag.trim() : String(tag)))
        .filter((tag) => tag !== "")

      if (filteredTags.length > 0) {
        formData.append("tags", filteredTags.join(", "))
      }

      formData.append("description", description)

      const filteredEducationList = educationList.filter(
        (item) => item.trim() !== "",
      )
      if (filteredEducationList.length > 0) {
        formData.append("educationList", filteredEducationList.join(", "))
      }

      const filteredAdditionalEducation = additionalEducation.filter(
        (item) => item.trim() !== "",
      )
      if (filteredAdditionalEducation.length > 0) {
        formData.append(
          "additionalEducation",
          filteredAdditionalEducation.join(", "),
        )
      }

      const filteredAchievements = achievements.filter(
        (item) => item.trim() !== "",
      )
      if (filteredAchievements.length > 0) {
        formData.append("achievments", filteredAchievements.join(", "))
      }

      if (
        benefits.length > 0 &&
        benefits.some(
          (benefit) =>
            benefit.BenefitText.trim() !== "" ||
            benefit.BenefitDescription.trim() !== "",
        )
      ) {
        formData.append("benefits", JSON.stringify(benefits))
      }

      setUploading(true)
      dispatch(
        trainersAction({
          flag: visible.flag === "add" ? "put" : "post",
          value: formData,
        }),
      ).then(() => {
        dispatch(trainersAction({ flag: "get" })).then(() => {
          setVisible({ open: false, flag: "" })
          setPage(1)
          setPageSize(20)
          setUploading(false)
        })
      })
    }
  }
  const handleChange = (info) => {
    if (info.fileList.length === 0) {
      setFileList([])
    } else {
      let newFileList = [...fileList]
      newFileList = newFileList.slice(-1)
      setFileList(newFileList)
    }
  }

  const uploadProps = {
    accept: ".png,.jpg,.jpeg",
    onRemove: () => {
      setFileList([])
    },
    onChange: handleChange,
    beforeUpload: (file) => {
      const isTooLarge = file.size / 1024 / 1024 > 1
      if (isTooLarge) {
        openNotification({
          type: "error",
          message: "Размер файла должен быть меньше одного мегабайта",
        })
        return false
      }
      setFileList([...fileList, file])
      return false
    },
    fileList,
  }

  const getSeniorities = () => {
    let arrSen = []
    for (let i = 1; i < 22; i++) {
      if (i === 1) {
        arrSen.push({ value: "0", label: "Менее одного года" })
      } else if (i == 2) {
        arrSen.push({ value: `${i - 1}`, label: `${i - 1} год` })
      } else if (i >= 3 && i <= 5) {
        arrSen.push({ value: `${i - 1}`, label: `${i - 1} года` })
      } else {
        arrSen.push({ value: `${i - 1}`, label: `${i - 1} лет` })
      }
    }
    return arrSen
  }

  const handleIsTopChange = (value) => {
    setIsTop(value)
    if (value === true && isMaster === true) {
      setIsMaster(false)
    }
  }

  const handleIsMasterChange = (value) => {
    setIsMaster(value)
    if (value === true && isTop === true) {
      setIsTop(false)
    }
  }

  const renderDynamicList = (
    title,
    items,
    handleChange,
    addItem,
    removeItem,
    placeholder,
  ) => (
    <div>
      <Typography.Title level={5}>
        {title}
        <Button
          type='dashed'
          onClick={addItem}
          icon={<PlusOutlined />}
          style={{ marginLeft: "10px" }}
        >
          Добавить
        </Button>
      </Typography.Title>

      {items.map((item, index) => (
        <div
          key={index}
          style={{ display: "flex", marginBottom: "8px", alignItems: "center" }}
        >
          <Input
            value={item}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder={placeholder}
            style={{ flex: 1, marginRight: "8px" }}
          />
          {items.length > 1 && (
            <Button
              type='text'
              danger
              icon={<DeleteOutlined />}
              onClick={() => removeItem(index)}
            />
          )}
        </div>
      ))}
    </div>
  )

  return (
    <CModal
      alignment='center'
      visible={visible.open}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible({ open: false, flag: "" })
      }}
      keyboard={true}
      size='xl'
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {visible.flag === "add"
            ? "Добавить тренера"
            : "Редактировать тренера"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Имя*</Typography.Title>
              <Input
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Тип*</Typography.Title>
              <Select
                onClick={() => {
                  visible.flag === "add" && dispatch(getTrainerTypes())
                }}
                style={{ width: "100%" }}
                value={type}
                onChange={(e) => setType(e)}
                options={trainerTypes?.data?.value}
              />
            </div>

            <div>
              <Typography.Title level={5}>Описание</Typography.Title>
              <TextArea
                value={description}
                onChange={(e) => setDescription(e.currentTarget.value)}
                placeholder='Введите описание тренера'
                rows={4}
                showCount
                maxLength={2000}
              />
            </div>

            <div>
              <Typography.Title level={5}>Теги</Typography.Title>

              {tags.length > 0 && (
                <div style={{ marginBottom: "10px" }}>
                  <Space wrap size={[0, 8]}>
                    {tags.map((tag, index) => (
                      <Tag
                        key={index}
                        closable
                        onClose={() => removeTag(index)}
                        style={{ marginBottom: "5px" }}
                      >
                        {tag}
                      </Tag>
                    ))}
                    {tags.length > 0 && (
                      <Button
                        type='text'
                        size='small'
                        onClick={clearAllTags}
                        style={{ padding: "0 5px", fontSize: "12px" }}
                      >
                        Очистить все
                      </Button>
                    )}
                  </Space>
                </div>
              )}

              <Input
                value={tagInput}
                onChange={handleTagInputChange}
                onKeyDown={handleTagInputKeyDown}
                onBlur={addTags}
                placeholder='Введите теги через запятую и нажмите Enter'
              />

              <div
                style={{ marginTop: "5px", fontSize: "12px", color: "#666" }}
              >
                Введите теги через запятую и нажмите Enter
              </div>
            </div>

            <div>
              <Typography.Title level={5}>Образование</Typography.Title>
              <Input
                value={education}
                onChange={(e) => setEducation(e.currentTarget.value)}
              />
            </div>

            {renderDynamicList(
              "Образование",
              educationList,
              handleEducationChange,
              addEducationItem,
              removeEducationItem,
              "Например: Высшее спортивное образование",
            )}

            {renderDynamicList(
              "Дополнительное образование",
              additionalEducation,
              handleAdditionalEducationChange,
              addAdditionalEducationItem,
              removeAdditionalEducationItem,
              "Например: Курсы тренеров ФИФА",
            )}

            {renderDynamicList(
              "Достижения",
              achievements,
              handleAchievementChange,
              addAchievementItem,
              removeAchievementItem,
              "Например: Чемпион мира 2020 года",
            )}

            <div>
              <Typography.Title level={5}>
                Ссылка на изображение
              </Typography.Title>
              <Input
                value={img}
                onChange={(e) => setImg(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Стаж*</Typography.Title>
              <Select
                style={{ width: "100%" }}
                value={seniority}
                options={getSeniorities()}
                onChange={(value, option) => setSeniority(option.label)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Клуб*</Typography.Title>
              <Select
                style={{ width: "100%" }}
                value={club}
                onChange={(e) => setClub(e)}
                options={clubs?.data?.value}
                onClick={() => {
                  visible.flag === "add" && dispatch(getClubs())
                }}
              />
            </div>

            <div>
              <Typography.Title level={5}>Высшая категория</Typography.Title>
              <Select
                style={{ width: "100%" }}
                value={isTop}
                onChange={handleIsTopChange}
                options={isBuyOptions}
              />
            </div>

            <div>
              <Typography.Title level={5}>Мастер</Typography.Title>
              <Select
                style={{ width: "100%" }}
                value={isMaster}
                onChange={handleIsMasterChange}
                options={isBuyOptions}
              />
            </div>

            <div>
              <Typography.Title level={5}>Цена за тренировку</Typography.Title>
              <Input
                value={price}
                onChange={(e) => setPrice(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>
                Изображение (размер меньше 1 МБ)
              </Typography.Title>
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>Выберите файл</Button>
              </Upload>
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible({ open: false, flag: "" })
          }}
          className='text-light'
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className='text-light'>
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditTrainerModal
